import React, { Component } from 'react'

/**
 * Clase para ver el inicio
 */
class Home extends Component {
    render() {
        return(
            <div>
                <h1 style={{textAlign: "center"}}>Bienvenido { localStorage.getItem("name")}</h1>
            </div>
        )
    }
}

export default Home;